import { POST } from '@/api'

/**
 * ログイン中ユーザー
 */
export default {
  namespaced: true,
  state: {
    user: {
      mail: null,
    },
    busy: false,
  },
  mutations: {
    busy(state, busy) {
      state.busy = busy
    },
  },
  actions: {
    /**
     * パスワード再設定
     */
    async changePassword({ state, commit }, { token, newPassword, confirmPassword }) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/password/update', { token, newPassword, confirmPassword })
      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
